document.addEventListener('alpine:init', () => {
  Alpine.data('logoCarousel', () => ({
    rows: [],
    rowLoads: [],
    progress: 0,
    speed: 1,

    init() {
      if (!document.body.classList.contains('wp-admin')) {
        this.$nextTick(() => {
          this.rows = [...this.$root.querySelectorAll('[data-row]')];
          this.speed = +this.$root.dataset.speed;
          this.tick = this.tick.bind(this);
          requestAnimationFrame(this.tick);
        });
      }
    },

    tick(t) {
      for (const [i, row] of this.rows.entries()) {
        const p = i % 2 ? 1 : -1;
        const o = row.offsetWidth / 2 + (window.innerWidth < 768 ? 12 : 24);
        let x = (p * t * this.speed) / 100;

        while (Math.abs(x) > o) {
          if (x > 0) {
            x -= o;
          } else {
            x += o;
          }
        }

        row.style.transform = `translate3d(${x}px, 0, 0)`;
      }

      requestAnimationFrame(this.tick);
    },
  }));
});